import { FourStatePiece } from '../../jscaip/FourStatePiece';
import { TableUtils } from '../../jscaip/TableUtils';
import { HexagonalGameState } from '../../jscaip/state/HexagonalGameState';
export class GipfState extends HexagonalGameState {
    sidePieces;
    capturedPieces;
    constructor(board, turn, sidePieces, capturedPieces) {
        super(turn, board, 7, 7, [3, 2, 1], FourStatePiece.EMPTY);
        this.sidePieces = sidePieces;
        this.capturedPieces = capturedPieces;
    }
    getScores() {
        return this.capturedPieces;
    }
    equals(other) {
        if (this.turn !== other.turn)
            return false;
        if (this.sidePieces.equals(other.sidePieces) === false)
            return false;
        if (this.capturedPieces.equals(other.capturedPieces) === false)
            return false;
        return TableUtils.equals(this.board, other.board);
    }
    getNumberOfPiecesToPlace(player) {
        return this.sidePieces.get(player);
    }
    getNumberOfPiecesCaptured(player) {
        return this.capturedPieces.get(player);
    }
    setAtUnsafe(coord, v) {
        const newBoard = TableUtils.copy(this.board);
        newBoard[coord.y][coord.x] = v;
        return new GipfState(newBoard, this.turn, this.sidePieces, this.capturedPieces);
    }
    isOnBoard(coord) {
        if (coord.isNotInRange(this.width, this.height)) {
            return false;
        }
        else {
            return this.getUnsafe(coord) !== FourStatePiece.UNREACHABLE;
        }
    }
}
